import request from '@/utils/request'
import { getSelectedRegion } from '@/utils/region'

export function login(data) {
  return request({
    url: '/vue-admin-template/user/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/vue-admin-template/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/api/user/logout',
    method: 'post'
  })
}

// 注销账号
export function logoff() {
  return request({
    url: '/api/user/logoff',
    method: 'post'
  })
}

// 发送短信验证码
export function sendSmsCode(data) {
  return request({
    url: '/api/sms/send',
    method: 'post',
    data
  })
}

// 手机号注册
export function mobileRegister(data) {
  return request({
    url: '/api/user/mobilelogin',
    method: 'post',
    data
  })
}

// 账号密码注册
export function accountRegister(data) {
  return request({
    url: '/api/user/register',
    method: 'post',
    data
  })
}

// 账号密码登录（extras 可传 silentError: true 抑制全局 Message，由调用方展示）
export function accountLogin(data, extras = {}) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data: {
      account: data.account,
      password: data.password,
      captcha: data.captcha
    },
    ...extras
  })
}

// 手机登录获取验证码
export function sendLoginSmsCode(data, extras = {}) {
  return request({
    url: '/api/sms/send',
    method: 'post',
    data,
    ...extras
  })
}

// 手机号登录
export function mobileLogin(data, extras = {}) {
  return request({
    url: '/api/user/mobilelogin',
    method: 'post',
    data,
    ...extras
  })
}

// 忘记密码发送验证码
export function sendForgetSmsCode(data) {
  return request({
    url: '/api/sms/send',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/api/user/resetpwd',
    method: 'post',
    data
  })
}

// 选择用户类型
export function selectUserType(data) {
  return request({
    url: '/api/account_type/selectUserType',
    method: 'post',
    data
  })
}

// 提交造价师信息
export function submitCostEngineerInfo(data) {
  return request({
    url: '/api/account_type/submitCostEngineerInfo',
    method: 'post',
    data
  })
}

// 获取专业领域
export function getProfessionalFields() {
  return request({
    url: '/api/account_type/getProfessionalFields',
    method: 'get'
  })
}

// 获取分类选项
export function getCategoryOptions() {
  return request({
    url: '/api/account_type/getCategoryOptions',
    method: 'get'
  })
}

// 上传图片
export function uploadImage(file) {
  const formData = new FormData()
  formData.append('file', file)

  return request({
    url: '/api/common/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 提交供应商信息
export function submitSupplierInfo(data) {
  return request({
    url: '/api/account_type/submitSupplierInfo',
    method: 'post',
    data
  })
}

// 造价师资质认证（个人中心）
// is_international: 0=国内 1=国际；engineer_level: 1=一级 2=二级；category_type=专业分类
export function submitCostEngineerCertification(data) {
  return request({
    url: '/api/user/submitCostEngineerCertification',
    method: 'post',
    data: {
      id_card_front: data.id_card_front,
      id_card_back: data.id_card_back,
      qualification_cert: data.qualification_cert,
      professional_field: data.professional_field,
      miaoshu: data.miaoshu || '',
      is_international: data.is_international,
      engineer_level: data.engineer_level,
      category_type: data.category_type,
      business_license: data.business_license || '',
      other_contact: data.other_contact || '',
      region: data.region || ''
    }
  })
}

// 供应商资质认证（个人中心）
export function certifySupplier(data) {
  return request({
    url: '/api/user/certifySupplier',
    method: 'post',
    data: {
      id_card_front: data.id_card_front,
      id_card_back: data.id_card_back,
      business_license: data.business_license,
      company_name: data.company_name,
      business_scope: data.business_scope
    }
  })
}

// 获取个人基本信息
export function getProfile() {
  return request({
    url: '/api/personal_center/getProfile',
    method: 'get'
  })
}

// 设置在线状态：online | invisible | busy
export function setPresence(data) {
  return request({
    url: '/api/user/setPresence',
    method: 'post',
    data
  })
}

// 获取顶部导航数据
export function getTopNav() {
  return request({
    url: '/api/home/getTopNav',
    method: 'get'
  })
}

// 获取底部信息数据
export function getBottomInfo() {
  return request({
    url: '/api/home/getBottomInfo',
    method: 'get'
  })
}

// 获取造价案例分类数据
export function getCostCaseCategory() {
  return request({
    url: '/api/cost_case/getCategory',
    method: 'get'
  })
}

// 获取首页导航数据
export function getHomeNav() {
  return request({
    url: '/api/home/getHomeNav',
    method: 'get'
  })
}

// 获取造价师列表
export function getEngineerList(params) {
  return request({
    url: '/api/cost_engineer/getEngineerList',
    method: 'get',
    params: {
      keyword: params.keyword || '',
      region: params.region || getSelectedRegion(),
      page: params.page || 1,
      limit: params.limit || 12
    }
  })
}

// 获取咨询对话记录列表
export function getConversationList(params) {
  return request({
    url: '/api/cost_engineer/getConversationList',
    method: 'get',
    params: {
      engineer_id: params.engineer_id,
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 创建咨询对话
export function createConversation(data) {
  const payload = {
    engineer_id: data.engineer_id,
    message: data.message,
    sender_type: data.sender_type // 1=用户，2=造价师
  }
  // 仅造价师发送时可传付费相关字段
  if (Number(data.sender_type) === 2) {
    payload.is_paid = data.is_paid || 0
    payload.amount = data.amount || '0.00'
  }
  return request({
    url: '/api/cost_engineer/createConversation',
    method: 'post',
    data: payload
  })
}

// 评价造价师
export function evaluateEngineer(data) {
  return request({
    url: '/api/cost_engineer/evaluateEngineer',
    method: 'post',
    data: {
      conversation_id: data.conversation_id,
      rating: data.rating,
      comment: data.comment
    }
  })
}

// 支付收费回复
export function payPaidReply(data) {
  return request({
    url: '/api/personal_center/payPaidReply',
    method: 'post',
    data: {
      reply_id: data.reply_id,
      payment_method: data.payment_method
    }
  })
}

// 获取造价师详情
export function getEngineerDetail(id) {
  return request({
    url: '/api/cost_engineer/getEngineerDetail',
    method: 'get',
    params: { id }
  })
}

// 更新造价师信息
export function updateCostEngineerInfo(data) {
  return request({
    url: '/api/personal_center/updateCostEngineerInfo',
    method: 'post',
    data: {
      specialty: data.specialty,
      region: data.region,
      title: data.title,
      engineer_level: data.engineer_level,
      honor_wall: data.honor_wall,
      introduction: data.introduction,
      avatar: data.avatar,
      miaoshu: data.miaoshu || ''
    }
  })
}

// 获取问答分类列表
export function getQACategoryList() {
  return request({
    url: '/api/cost_qa/categoryList',
    method: 'get'
  })
}

// 获取问题列表
export function getQuestionList(params) {
  return request({
    url: '/api/cost_qa/questionList',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      category_id: params.category_id || '',
      keyword: params.keyword || ''
    }
  })
}

// 获取问题详情
export function getQuestionDetail(question_id) {
  return request({
    url: '/api/cost_qa/questionDetail',
    method: 'get',
    params: { question_id }
  })
}

// 获取收藏的问答列表
export function getFavoriteList(params) {
  return request({
    url: '/api/cost_qa/getFavoriteList',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 20
    }
  })
}

// 收藏问答
export function addFavorite(question_id) {
  return request({
    url: '/api/cost_qa/addFavorite',
    method: 'post',
    data: { question_id }
  })
}

// 取消收藏问答
export function cancelFavorite(question_id) {
  return request({
    url: '/api/cost_qa/cancelFavorite',
    method: 'post',
    data: { question_id }
  })
}

// 发布问题
export function postQuestion(data) {
  return request({
    url: '/api/cost_qa/postQuestion',
    method: 'post',
    data: {
      category_id: data.category_id,
      title: data.title,
      content: data.content,
      images: data.images,
      reward_amount: data.reward_amount,
      province: data.province || '',
      city: data.city || ''
    }
  })
}

// 获取我的问题列表
export function getMyQuestions(params) {
  return request({
    url: '/api/cost_qa/myQuestions',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 回复问题（images：多张图片 URL 逗号分隔；file：单个附件 URL）
export function answerQuestion(data) {
  return request({
    url: '/api/cost_qa/answerQuestion',
    method: 'post',
    data: {
      question_id: data.question_id,
      content: data.content,
      images: data.images != null ? data.images : '',
      file: data.file != null ? data.file : ''
    }
  })
}

// 采纳回答
export function adoptAnswer(data) {
  return request({
    url: '/api/cost_qa/adoptAnswer',
    method: 'post',
    data: {
      answer_id: data.answer_id
    }
  })
}

// 提问人追问
export function askFollowup(data) {
  return request({
    url: '/api/cost_qa/askFollowup',
    method: 'post',
    data: {
      question_id: data.question_id,
      answer_id: data.answer_id,
      content: data.content,
      images: data.images != null ? data.images : ''
    }
  })
}

// 回答者回复追问
export function replyFollowup(data) {
  return request({
    url: '/api/cost_qa/replyFollowup',
    method: 'post',
    data: {
      question_id: data.question_id,
      answer_id: data.followup_id,
      content: data.content,
      images: data.images != null ? data.images : ''
    }
  })
}

// 获取我的回答列表
export function getMyAnswers(params) {
  return request({
    url: '/api/cost_qa/myAnswers',
    method: 'get',
    params: {
      type: params.type || 'adopted',
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 获取问答收入
export function getQAIncome(params) {
  return request({
    url: '/api/cost_qa/qaIncome',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 获取历史记录
export function getHistory(params) {
  return request({
    url: '/api/cost_qa/history',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 更新个人资料
export function updateProfile(data) {
  return request({
    url: '/api/personal_center/updateProfile',
    method: 'post',
    data: {
      nickname: data.nickname,
      avatar: data.avatar
    }
  })
}

// 实名认证
export function realNameAuth(data) {
  return request({
    url: '/api/personal_center/realNameAuth',
    method: 'post',
    data: {
      real_name: data.real_name,
      id_card: data.id_card
    }
  })
}

// 获取实名认证状态
export function getRealNameStatus() {
  return request({
    url: '/api/personal_center/getRealNameStatus',
    method: 'get'
  })
}

// 提现：1=银行卡(bank_name、account、bank_branch)，2=微信/3=支付宝(payment_qr_code 收款码)
export function withdraw(data) {
  const payload = {
    withdraw_type: data.withdraw_type,
    amount: data.amount,
    payment_password: data.payment_password
  }
  const t = Number(data.withdraw_type)
  if (t === 1) {
    payload.bank_name = data.bank_name
    payload.account = data.account
    payload.bank_branch = data.bank_branch
  } else if (t === 2 || t === 3) {
    payload.payment_qr_code = data.payment_qr_code
  }
  return request({
    url: '/api/personal_center/withdraw',
    method: 'post',
    data: payload
  })
}

// 设置支付密码
export function setPaymentPassword(data) {
  return request({
    url: '/api/personal_center/setPaymentPassword',
    method: 'post',
    data: {
      password: data.password
    }
  })
}

// 获取账单记录
export function getMoneyLog(params) {
  return request({
    url: '/api/personal_center/getMoneyLog',
    method: 'get',
    params: {
      type: params.type || '',
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 获取我的关注列表
export function getMyFollows(params) {
  return request({
    url: '/api/personal_center/getMyFollows',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 获取供应商信息
export function getSupplierInfo() {
  return request({
    url: '/api/personal_center/getSupplierInfo',
    method: 'get'
  })
}

// 更新供应商信息
export function updateSupplierInfo(data) {
  return request({
    url: '/api/personal_center/updateSupplierInfo',
    method: 'post',
    data: {
      id: data.id,
      company_name: data.company_name,
      main_business: data.main_business,
      region: data.region,
      phone: data.phone,
      other_contact: data.other_contact
    }
  })
}

// 获取我的收藏列表
export function getMyCollections(params) {
  return request({
    url: '/api/personal_center/getMyCollections',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 获取发票模板列表
export function getInvoiceTemplates() {
  return request({
    url: '/api/personal_center/getInvoiceTemplates',
    method: 'get'
  })
}

// 获取可申请发票订单列表
export function getInvoiceableOrders(params) {
  return request({
    url: '/api/personal_center/getInvoiceableOrders',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 获取已申请发票订单列表
export function getAppliedInvoiceOrders(params) {
  return request({
    url: '/api/personal_center/getAppliedInvoiceOrders',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      invoice_status: params.invoice_status || 0
    }
  })
}

// 保存发票模板
export function saveInvoiceTemplate(data) {
  return request({
    url: '/api/personal_center/saveInvoiceTemplate',
    method: 'post',
    data: {
      template_name: data.template_name,
      invoice_type: data.invoice_type,
      company_name: data.company_name,
      taxpayer_id: data.taxpayer_id,
      address: data.address || '',
      phone: data.phone || '',
      bank_name: data.bank_name || '',
      bank_account: data.bank_account || '',
      is_default: data.is_default || 0
    }
  })
}

// 申请发票
export function applyInvoice(data) {
  return request({
    url: '/api/personal_center/applyInvoice',
    method: 'post',
    data: {
      order_ids: data.order_ids,
      template_id: data.template_id
    }
  })
}

// 提交问题反馈
export function submitFeedback(data) {
  return request({
    url: '/api/personal_center/submitFeedback',
    method: 'post',
    data: {
      feedback_type: data.feedback_type,
      content: data.content,
      images: data.images || []
    }
  })
}

// 修改手机号
export function changeMobile(data) {
  return request({
    url: '/api/user/changemobile',
    method: 'post',
    data: {
      mobile: data.mobile,
      captcha: data.captcha
    }
  })
}

// 更换邮箱
export function changeEmail(data) {
  return request({
    url: '/api/user/changeemail',
    method: 'post',
    data: {
      email: data.email,
      captcha: data.captcha,
      password: data.password
    }
  })
}

// 提交申诉
export function submitAppeal(data) {
  return request({
    url: '/api/personal_center/submitAppeal',
    method: 'post',
    data: {
      content: data.content,
      images: data.images || []
    }
  })
}

// 获取我的案例
export function getMyCostCases(params) {
  return request({
    url: '/api/personal_center/getMyCostCases',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 删除我的案例
export function deleteCostCase(params) {
  return request({
    url: '/api/personal_center/deleteCostCase',
    method: 'get',
    params: {
      case_ids: params.case_ids
    }
  })
}

// 获取案例详情
export function getCostCaseDetail(case_id) {
  return request({
    url: '/api/personal_center/getCostCaseDetail',
    method: 'get',
    params: { case_id }
  })
}

// 获取留言列表
export function getMessageBoardList(params) {
  return request({
    url: '/api/personal_center/getMessageBoardList',
    method: 'get',
    params: {
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 修改留言板联系人备注
export function updateMessageBoardRemark(data) {
  return request({
    url: '/api/personal_center/updateMessageBoardRemark',
    method: 'post',
    data: {
      contact_id: data.contact_id,
      remark: data.remark
    }
  })
}

// 获取对话详情
export function getConversationDetail(params) {
  return request({
    url: '/api/personal_center/getConversationDetail',
    method: 'get',
    params: {
      user_id: params.user_id,
      page: params.page || 1,
      limit: params.limit || 10
    }
  })
}

// 上传案例
export function uploadCostCase(data) {
  return request({
    url: '/api/personal_center/uploadCostCase',
    method: 'post',
    data: {
      title: data.title,
      category_id: data.category_id,
      address: data.address,
      region: data.region,
      scale: data.scale,
      structure_system: data.structure_system,
      cost_indicators: data.cost_indicators,
      project_description: data.project_description,
      other_indicators: data.other_indicators,
      images: data.images,
      data_table_file: data.data_table_file,
      template_file: data.template_file,
      is_free: data.is_free,
      price: data.price
    }
  })
}

// 开通会员
export function activateMembership(data = {}) {
  return request({
    url: '/api/personal_center/activateMembership',
    method: 'post',
    data
  })
}

// 充值余额
export function rechargeBalance({ amount, paytype }) {
  return request({
    url: '/api/personal_center/rechargeBalance',
    method: 'post',
    data: { amount, paytype }
  })
}

// 用户注册（extras 可传 silentError）
export function registerUser(data, extras = {}) {
  return request({
    url: '/api/user/registerUser',
    method: 'post',
    data: {
      username: data.username,
      password: data.password,
      captcha: data.captcha
    },
    ...extras
  })
}

// 造价师注册
export function registerCostEngineer(data, extras = {}) {
  const payload = {
    username: data.username,
    password: data.password,
    captcha: data.captcha,
    name: data.name,
    phone: data.phone,
    entry_type: data.entry_type || 1 // 1个人 2企业，默认为1
  }
  if (data.business_license) {
    payload.business_license = data.business_license
  }
  return request({
    url: '/api/user/registerCostEngineer',
    method: 'post',
    data: payload,
    ...extras
  })
}

// 供应商注册
export function registerSupplier(data, extras = {}) {
  return request({
    url: '/api/user/registerSupplier',
    method: 'post',
    data: {
      username: data.username,
      password: data.password,
      captcha: data.captcha,
      name: data.name,
      phone: data.phone,
      id_card_front: data.id_card_front,
      id_card_back: data.id_card_back,
      company_name: data.company_name,
      business_scope: data.business_scope,
      business_license: data.business_license || '' // 营业执照
    },
    ...extras
  })
}

